import React, { Component, useState, useEffect, useRef, createRef } from 'react'
import { connect } from 'react-redux'
import { Table, FormControl, Image, Button, OverlayTrigger, Tooltip, Form, Collapse } from 'react-bootstrap'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment'
import 'moment/locale/de'

import '../../index.css'
import { FetchReadIncomingTransactions, FetchApproveCorrection, FetchArticleTypeImages } from '../../fetcher';
import { getSizeEntries, getSizeNumbers, getCorrectionNumbers, getTotal } from '../presentational-components/TableComponent'
import AlertMessage from '../presentational-components/AlertMessage';
import { ModalComponent } from '../presentational-components/ModalComponent';
import DescriptionTooltip from '../presentational-components/DescriptionTooltip'
import { RenderImage } from '../presentational-components/ImageViewer'
import EnumValueTranslations from '../presentational-components/EnumValueTranslations';
import { ExportCSV } from '../presentational-components/ExportCSV';
import { useExpandRows, useSortTransactions } from '../presentational-components/tablehooks';
import { DateSelect, StateSelect, useDateFilter, useFilterTransactions, useSearchFilter, useSelectFilter } from '../presentational-components/filterutils';
import LoadingSpinner from '../presentational-components/LoadingSpinner';


moment.locale('de')

const getColourClassStatus = (status) => {
    //if (status == "InTransit") return "inTransit"
    if (status == "Confirmed") return "approved"
    else if (status == "Inaccurate") return "correction"
    else return "inTransit"
}

const correctionColor = (inaccurateState) => {
    return (inaccurateState == true ? "correction-corrected" : "correction-approved")
}

const IncomingTransaction = () => {
    const [showAlertMessage, setShowAlert] = useState(false)
    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }
    const [taskName, setTaskName] = useState("IncomingTransaction unbekannte Task")

    const [alertMessage, setAlertMessage] = useState("")

    const [incomingTransactions, setIncomingTransactions] = useState([])
    const [articleDataReady, setArticleDataToReady] = useState(false)

    const addingImages = (articleTypeImages) => {
        let copiedIncomingTransactions = [...incomingTransactions]
        articleTypeImages.forEach(image => copiedIncomingTransactions.flatMap(x => x.Articles).filter(x => x.ArticleTypeSysId == image.ArticleTypeSysId).forEach(xfiltered => xfiltered.Image = 'data:image/png;base64,' + image.Data))
        setIncomingTransactions(copiedIncomingTransactions)
    }

    const [filteredIncomingTransactions, setFilteredIncomingTransactions] = useState([])
    const [sortedIncomingTransactions, setSortedIncomingTransactions] = useState([])
    const [filterArticles, setFilterArticles] = useState(false)
    const toggleFilterArticles = () => {
        setFilterArticles(!filterArticles)
    }

    const { sortTransactions } = useSortTransactions(incomingTransactions, setSortedIncomingTransactions)
    const { expandRow, getIsExpandedRow } = useExpandRows()
    const { filterTransactionsBySearchInput, filterTransactionsByDateInput, filterTransactionsBySelectInput, filterTransactionsAndArticlesBySearchInput } = useFilterTransactions()
    const { dateSelect, handleDatePickerCallback, handleClearFilter } = useDateFilter()
    const [statusSelect, handleStatusSelectChange] = useSelectFilter()
    const { searchInput, handleSearchInput } = useSearchFilter()

    const handleSetIncomingTransactions = (transactions) => {
        // ZD 2022.01.25 temporarily only
        console.log("ZD 2022.01.25 temporarily only ", transactions)
        setIncomingTransactions(transactions.filter(x => x.Type != "NewArrivals" && x.Type != "CorrectionForNewArrivals" && x.State != "Confirmed"))
    }

    useEffect(() => {
        setTaskName("Die eingehende Transaktionen werden geladen")
        FetchReadIncomingTransactions(handleSetIncomingTransactions, openAlert, setArticleDataToReady, undefined, "IncomingTransactions")
        console.log(incomingTransactions)
    }, []);

    useEffect(() => {
        if (articleDataReady) {
            setTaskName("Die Bilder werder geladen")
            FetchArticleTypeImages(incomingTransactions.flatMap(x => x.Articles).map(x => x.ArticleTypeSysId.toString(), "IncomingTransactions"), addingImages, openAlert)
        }
    }, [articleDataReady])

    useEffect(() => {
        console.log("Just checking IncomingTransactions ", incomingTransactions)

    }, [incomingTransactions])

    useEffect(() => {
        setFilteredIncomingTransactions([...incomingTransactions])
        setSortedIncomingTransactions([...incomingTransactions])
    }, [incomingTransactions])

    const takeSortedIncomingTransactions = () => {
        //Maybe this shouldn't be done in general, as there should be another option to deep clone an object!
        let deepCopy = JSON.parse(JSON.stringify(sortedIncomingTransactions))
        return deepCopy
    }

    const reload = () => {
        setTaskName("Die eingehende Transaktionen werden geladen")
        FetchReadIncomingTransactions(handleSetIncomingTransactions, openAlert, setArticleDataToReady)
    }

    useEffect(() => {
        let filteredTransactions = filterArticles ? filterTransactionsAndArticlesBySearchInput(takeSortedIncomingTransactions(), searchInput) : filterTransactionsBySearchInput(sortedIncomingTransactions, searchInput)
        filteredTransactions = filterTransactionsByDateInput(filteredTransactions, dateSelect)
        filteredTransactions = filterTransactionsBySelectInput(filteredTransactions, statusSelect)

        setFilteredIncomingTransactions(filteredTransactions)
    }, [searchInput, dateSelect, statusSelect, sortedIncomingTransactions, filterArticles])

    const [newCorrections, setNewCorrections] = useState([])
    const [correctionAmounts, setCorrectionAmounts] = useState([])

    const [corrections, setCorrections] = useState([])
    const openCorrectionLine = (transactionSysId, articleSysId) => {
        const uniqueCorrectionId = transactionSysId + "__" + articleSysId
        if (corrections.includes(uniqueCorrectionId)) {
            setCorrections(corrections.filter(item => item !== uniqueCorrectionId))
            correctionRefs.current = correctionRefs.current.filter(item => item.value !== null)
        } else {
            const newCorrections = [...corrections]
            newCorrections.push(uniqueCorrectionId)
            setCorrections(newCorrections)
        }
    }

    let correctionRefs = useRef([]);

    const getCorrectionInputFields = (transactionSysId, articleSysId, sizeEntries) => {
        return (
            <>
                {sizeEntries.map(entry =>
                    <td className="numberColumn">
                        <Form>
                            <Form.Control className="sizeAmount-correction" as="input" defaultValue="0" type="number" size="sm" ref={node => correctionRefs.current[transactionSysId + "__" + articleSysId + "__" + entry.SizeValue] = node} />
                        </Form>
                    </td>)
                }
            </>
        )
    }

    const getNewCorrectionValues = (articleSizes) => {
        return (
            <>
                {articleSizes.map(entry =>
                    entry.NewCorrectionAmount !== undefined ?
                        <td className="numberColumn">{(entry.NewCorrectionAmount > 0 ? "+" : "") + entry.NewCorrectionAmount}</td>
                        : null)
                }
            </>
        )
    }

    const [showConfirmationModal, setShowConfirmationModel] = useState(false)
    const [confirmTransactionSysId, setTransactionSysId] = useState("")
    const [confirmTransactionState, setTransactionState] = useState("")

    const [modalTitle, setModalTitle] = useState("")
    const [modalDescription, setModalDescription] = useState("")

    const handleCloseConfirmationModal = () => setShowConfirmationModel(false)

    const getCsvFileName = (transactionSysId, date, deliveryTo) => {
        return (date.replace(".", "-") + "_Lieferschein_Von_" + deliveryTo)
    }

    const getCsvData = (articles, sizeCategories) => {
        let csvArrayData = []

        sizeCategories.forEach(x => {

            let csvData = []

            articles.sort((a, b) => a.DesignerName.localeCompare(b.DesignerName) || a.Name.localeCompare(b.Name))
                .filter(y => y.SizeCat === x).forEach(article => {

                    let object =
                    {
                        "Designername": article.DesignerName,
                        "Artikelnr. FAEX": article.ArticleIdFaex,
                        "Artikelnr. Designer": article.ArticleNumberDesigner,
                        "Artikelname": article.Name,
                        "Größenkategorie": x,
                        "Farbe": article.Colour,
                        "Vk-Preis": article.SalePrice,
                    }

                    article.Sizes.forEach(size => {
                        let key = size.SizeValue.toString() + " "
                        let value = size.Amount
                        let sizePair = { [key]: value }

                        object = { ...object, ...sizePair }
                    })

                    let numbers = article.Sizes.map(entry => parseInt(entry.Amount))
                    let total = 0
                    numbers.map(number => total = parseInt(total) + parseInt(number))
                    let totalPair = { "Total": total }
                    object = { ...object, ...totalPair }

                    csvData.push(object)
                }
                )
            csvArrayData.push(csvData)
        })

        return (csvArrayData)
    }

    const getTotalTotal = (articleTypes) => {
        let numbersTotal = 0
        articleTypes.forEach(x => {
            let numbers = x.Sizes.map(entry => parseInt(entry.Amount))
            let total = 0
            numbers.map(number => total = parseInt(total) + parseInt(number))

            numbersTotal += total
        })

        return numbersTotal
    }

    function handleShowConfirmationModal(transactionSysId, transactionState, stateCorrectedBool) {
        setShowConfirmationModel(true)
        setTransactionSysId(transactionSysId)
        setTransactionState(stateCorrectedBool == true ? "_corrected" : transactionState)

        console.log("DEBUG TransactionState")
        console.log(transactionState)
        
        if (stateCorrectedBool == true) {
            setModalTitle("Korrektur bestätigen")
            setModalDescription("Möchten Sie die Korrektur bestätigen?")
        }

        else if (transactionState == "InProcess") {
            setModalTitle("Lieferung bestätigen")
            setModalDescription("Möchten Sie die Lieferung akzeptieren?" + "\n" + "Anschließend ist keine Korrektur mehr möglich.")
        }
        else if (transactionState == "InTransit") {
            setModalTitle("Liefereingang bestätigen")
            setModalDescription("Möchten Sie den Liefereingang akzeptieren?")
        }
        else if (transactionState == "Arrived") {
            setModalTitle("Bearbeitung bestätigen")
            setModalDescription("Möchten Sie die Bearbeitung beginnen? Sie können Korrekturen hinzufügen.")
        }
    }

    function addNewCorrectionForArticle(transactionSysId, articleSysId, sizeEntries, article) {
        let invalid = false
        console.log("invalid?")
        console.log(sizeEntries)
        console.log(correctionRefs.current)
        if (sizeEntries.every(x => (x.Amount + parseInt(correctionRefs.current[transactionSysId + "__" + articleSysId + "__" + x.SizeValue].value)) >= 0)) {
            invalid = false
            console.log(invalid)
        } else {
            invalid = true
            console.log(invalid)
        }

        if (invalid == false) {
            const uniqueCorrectionId = transactionSysId + "__" + articleSysId
            const newCorrection = [...newCorrections]
            newCorrection.push(uniqueCorrectionId)
            setNewCorrections(newCorrection)

            const newCorrectionAmounts = [...correctionAmounts]

            sizeEntries.forEach(x => {
                newCorrectionAmounts.push({ name: (transactionSysId + "__" + articleSysId + "__" + x.SizeValue), value: correctionRefs.current[transactionSysId + "__" + articleSysId + "__" + x.SizeValue].value })
                x.NewCorrectionAmount = correctionRefs.current[transactionSysId + "__" + articleSysId + "__" + x.SizeValue].value
            })

            setCorrectionAmounts(newCorrectionAmounts)

            const transactionWithNewCorrection = incomingTransactions.filter(x => x.TransactionSysId == transactionSysId)[0]
            if (transactionWithNewCorrection != null) transactionWithNewCorrection.StateCorrected = "_corrected"
        } else {
            console.log(invalid)
            setAlertMessage("Die korrigierten Werte dürfen keine negative Bilanz aufweisen.")
            openAlert()
        }
    }

    const handleApproveTransaction = () => {
        if (confirmTransactionSysId != "") {
            const stateChangeModel = {
                AbstractTransactionSysId: confirmTransactionSysId,
                OldState: confirmTransactionState,
                NewCorrections: incomingTransactions.filter(x => x.TransactionSysId == confirmTransactionSysId)[0].Articles
            };

            setNewCorrections([])
            setTaskName("FetchApproveCorrection")
            FetchApproveCorrection(stateChangeModel, handleCloseConfirmationModal, reload, openAlert)
        }
    }

    const [filterable, setFilterable] = useState(false)
    const setFilterbar = () => {
        setFilterable(!filterable)
    }

    return (
        <div>
            <h1 className="tablet-center">Posteingang</h1>
            <div className="flex-linebreak"></div>

            <div className="inline">
                <FormControl className="globalSearch searchBar" as="input" defaultValue={searchInput} placeholder="Suche..." onChange={handleSearchInput}></FormControl>
                <Button variant="light" className="filter-button form-control" onClick={toggleFilterArticles}>{filterArticles ? "Lieferscheine filtern" : "Artikel filtern"}</Button>
            </div>

            <div className="tablet-transactions">
                <Table className="table-sm table-striped-immediate">
                    <thead className="sticky-table-header">
                        <th></th>
                        <th className="mainColumn">Lieferung von
                            <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'SourceOrTargetName')}>&#8593; &#8595;</a>
                        </th>
                        <th className="mainColumn">Erstellungsdatum
                            <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'CreationDate')}>&#8593; &#8595;</a>
                        </th>
                        <th className="mainColumn">Status
                            <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'State')}>&#8593; &#8595;</a>
                        </th>
                        <th className="mainColumn">Bemerkung
                            <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'Remark')}>&#8593; &#8595;</a>
                        </th>
                        <th className="filterIndicator" onClick={setFilterbar}>&#8711; Filter</th>
                        <th></th>
                    </thead>
                    {filterable ? <thead>
                        <th></th><th></th>
                        <th>{DateSelect(handleDatePickerCallback, handleClearFilter, dateSelect)}</th>
                        <th>{StateSelect([...new Set(incomingTransactions.map(x => EnumValueTranslations(x.State)))], handleStatusSelectChange, statusSelect)}</th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </thead> : null}
                    <tbody>
                        {filteredIncomingTransactions.map((transaction) =>
                            <>
                                <tr className="salesboutique-mainrow" onClick={(e) => expandRow(e, transaction.TransactionSysId)} aria-expanded={getIsExpandedRow(transaction.TransactionSysId)} aria-controls={transaction.TransactionSysId}>
                                    {getIsExpandedRow(transaction.TransactionSysId) ? <td className="expandIndicator">&#8722;</td> : <td className="expandIndicator">&#43;</td>}
                                    <td>{transaction.SourceOrTargetName}</td>
                                    <td>{transaction.CreationDate}</td>
                                    <td className={getColourClassStatus(transaction.State)}>{EnumValueTranslations(transaction.State)}</td>
                                    <OverlayTrigger trigger={["hover", "click"]} placement="top" overlay={DescriptionTooltip(transaction.Remark)}>
                                        <td className="remark-td">{transaction.Remark}</td>
                                    </OverlayTrigger>
                                    <td></td>
                                </tr>

                                <Collapse in={getIsExpandedRow(transaction.TransactionSysId)} timeout={30}>
                                    <td colSpan="6" className="td-nomargin">
                                        <div id={transaction.TransactionSysId} className="salesBoutique-child-div">
                                            {[...new Set(transaction.Articles.map(article => article.SizeCat))].map(sizeCat =>
                                                <>
                                                    <thead className="sticky-table-header">
                                                        <tr>
                                                            <th className="imageColumn"></th>
                                                            <th>Designername</th>
                                                            <th>Artikelnr. FAEX</th>
                                                            <th>Artikelnr. Designer</th>
                                                            <th>{sizeCat}</th>
                                                            <th>Farbe</th>
                                                            <th>Vk-Preis</th>
                                                            {getSizeEntries(transaction.Articles.find(x => x.SizeCat === sizeCat).Sizes)}
                                                            <th className="sizeColumn">Total</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {transaction.Articles.sort((a, b) => a.Name.localeCompare(b.Name))
                                                        .filter(x => x.SizeCat === sizeCat).map(article =>
                                                            <>
                                                                <tr>
                                                                    <td className="imageColumn">{RenderImage(article.Image)}</td>
                                                                    <td>{article.DesignerName}</td>
                                                                    <td>{article.ArticleIdFaex}</td>
                                                                    <td>{article.ArticleNumberDesigner}</td>
                                                                    <td>{article.Name}</td>
                                                                    <td>{article.Colour}</td>
                                                                    <td className="numberColumn">{parseFloat(article.SalePrice).toFixed(2).replace('.', ',') + "€"}</td>
                                                                    {getSizeNumbers(article.Sizes)}
                                                                    {getTotal(article.Sizes)}

                                                                    {transaction.State == "InProcess" ?
                                                                        <td>
                                                                            <OverlayTrigger placement="bottom" overlay={<Tooltip> Korrektur anlegen </Tooltip>}>
                                                                                <Button className="button-mar" size="sm" variant="secondary" onClick={() => openCorrectionLine(transaction.TransactionSysId, article.ArticleTypeSysId)}>&#9998;</Button>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                        : null}
                                                                </tr>

                                                                {article.CorrectedArticles == true ?
                                                                    <tr className={correctionColor(transaction.State)}>
                                                                        <td />
                                                                        <td />
                                                                        <td />
                                                                        <td />
                                                                        <td>Korrektur:</td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        {getCorrectionNumbers(article.Sizes)}
                                                                    </tr>
                                                                    : null}

                                                                {newCorrections.includes(transaction.TransactionSysId + "__" + article.ArticleTypeSysId) == true ?
                                                                    <tr className="correction-corrected">
                                                                        <td className="new-correction">Neue Korrektur:</td>
                                                                        <td />
                                                                        <td />
                                                                        <td />
                                                                        <td />
                                                                        <td />
                                                                        {getNewCorrectionValues(article.Sizes)}

                                                                    </tr>
                                                                    : null}

                                                                {corrections.includes(transaction.TransactionSysId + "__" + article.ArticleTypeSysId) == true ?
                                                                    <tr>
                                                                        <td />
                                                                        <td />
                                                                        <td />
                                                                        <td />
                                                                        <td />
                                                                        <td />
                                                                        {getCorrectionInputFields(transaction.TransactionSysId, article.ArticleTypeSysId, article.Sizes)}
                                                                        <td />
                                                                        <td>
                                                                            <OverlayTrigger placement="bottom" overlay={<Tooltip> Korrektur bestätigen </Tooltip>}>
                                                                                <Button className="button-mar" size="sm" variant="secondary" onClick={() => addNewCorrectionForArticle(transaction.TransactionSysId, article.ArticleTypeSysId, article.Sizes, article)}>&#10003;</Button>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                    </tr>
                                                                    : null}
                                                            </>
                                                        )}

                                                        <tr className="stockReport-row">
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>Summe: </td>
                                                            <td>{getTotalTotal(transaction.Articles)}</td>
                                                        </tr>

                                                    </tbody>
                                                </>
                                            )}
                                        </div>

                                        {transaction.StateCorrected == "_corrected" ?
                                            <tr>
                                                <td></td>
                                                <td><Button variant="secondary" size="sm" onClick={() => handleShowConfirmationModal(transaction.TransactionSysId, transaction.State, true)}>Korrektur abschicken</Button></td>
                                            </tr>
                                            : null}

                                        {(transaction.StateCorrected == "" || transaction.StateCorrected == undefined) && transaction.State == "InProcess" ?
                                            <tr>
                                                <td></td>
                                                <td><Button variant="secondary" size="sm" onClick={() => handleShowConfirmationModal(transaction.TransactionSysId, transaction.State)}>Lieferung bestätigen &#10003;</Button></td>
                                            </tr>
                                            : null}

                                        {(transaction.StateCorrected == "" || transaction.StateCorrected == undefined) && transaction.State == "InTransit" ?
                                            <tr>
                                                <td></td>
                                                <td><Button variant="secondary" size="sm" onClick={() => handleShowConfirmationModal(transaction.TransactionSysId, transaction.State)}>Liefereingang bestätigen &#10003;</Button></td>
                                            </tr>
                                            : null}

                                        {(transaction.StateCorrected == "" || transaction.StateCorrected == undefined) && transaction.State == "Arrived" ?
                                            <tr>
                                                <td></td>
                                                <td><Button variant="secondary" size="sm" onClick={() => handleShowConfirmationModal(transaction.TransactionSysId, transaction.State)}>Bearbeitung bestätigen &#10003;</Button></td>
                                            </tr>
                                            : null}

                                        <tr>
                                            <td></td>
                                            <td><ExportCSV className="transactionExport" disabled={false} csvData={() => getCsvData(transaction.Articles, [...new Set(transaction.Articles.map(article => article.SizeCat))])} fileName={getCsvFileName(transaction.TransactionSysId, transaction.CreationDate, transaction.SourceOrTargetName)} isTransaction={true} /></td>
                                        </tr>

                                    </td>
                                </Collapse>
                            </>
                        )}
                    </tbody>
                </Table>
            </div>

            <ModalComponent handleShow={showConfirmationModal} handleClose={handleCloseConfirmationModal} handleSubmit={handleApproveTransaction}
                reload={reload} modalTitle={modalTitle} modalBody={modalDescription} />

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} message={alertMessage} />
            <LoadingSpinner task={taskName} area={"IncomingTransactions"} />

        </div>
    );
}

const mapStateToProps = state => ({
})

export default connect(mapStateToProps)(IncomingTransaction)
